module.exports = __webpack_public_path__ + "static/media/logo-text.cb07b54f.png";